import script from "./SyntheticDataForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyntheticDataForm.vue?vue&type=script&lang=ts&setup=true"

import "./SyntheticDataForm.vue?vue&type=style&index=0&id=30e1958c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e1958c"]])

export default __exports__